export const ENV = {
  SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL as string,
  SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY as string,
  API_BASE: (import.meta.env.VITE_API_BASE as string | undefined) ?? '',
  // Cloudflare Turnstile site key (PUBLIC by design; domain-locked to reptree.io). The widget renders only
  // when this is set; auth forms pass its token to Supabase, which enforces it once captcha is switched on.
  // Overridable per environment via VITE_TURNSTILE_SITE_KEY; the default is the reptree.io widget.
  TURNSTILE_SITE_KEY: (import.meta.env.VITE_TURNSTILE_SITE_KEY as string | undefined) ?? '0x4AAAAAAFIig0EBueaI-vW-',
  // The WebAuthn relying party RepTree's server checks passkeys against (server PASSKEY_RP_ID). A browser only runs a
  // passkey ceremony for this id on this exact host, so passkeys are offered only there (lib/passkey.ts).
  // Overridable per environment via VITE_PASSKEY_RP_ID (a staging project, or a local test on localhost).
  PASSKEY_RP_ID: (import.meta.env.VITE_PASSKEY_RP_ID as string | undefined) ?? 'reptree.io',
}
